import React, { useEffect } from "react";
import { useState, useRef } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Autocomplete from "@mui/material/Autocomplete";
import { useFormik } from "formik";
import * as Yup from "yup";
import useAxios from "../../../api/useAxios";
import "./JobSeekerRegForm.css";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import { useNavigate } from "react-router";
import { ROUTINGDATA } from "../../ROUTINGDATA";
import { FormHelperText, CircularProgress } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { useTranslation } from "react-i18next";
import Popper from "@mui/material/Popper";
import { useLocationFind } from "../LocationFind";
import PersonIcon from "@mui/icons-material/Person";
import leftimg from "../../../img/Left.png";
import EmailIcon from "@mui/icons-material/Email";
import Stack from "@mui/material/Stack";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import svgmale from "../../../img/male 1.png";
import svggirl from "../../../img/Group 1.png";
import Student from "../../../img/student-reading 1.png";
import Graduate from "../../../img/graduate 2.png";
import Industry from "../../../img/economy 2.png";
import Location from "../../../img/location (1) 1.png";
import pincodeimg from "../../../img/navigation-2.png";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import svgmaleActive from "../../../img/male-Active.png";
import svggirlActive from "../../../img/femaleActive.png";
import StudentActive from "../../../img/student-reading-active.png";
import GraduateActive from "../../../img/graduate-active.png";
import Graduateworksatus from "../../../img/graduate-work-status.png";
import workexstatus from "../../../img/work-ex-status.png";
import workactive from "../../../img/work-active.png";
import fresher from "../../../img/graduate-2-active.png";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import districtActive from "../../../img/location-active.png";
import leftTamil from "../../../img/Left-tamil.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import sussesfullimg from "../../../img/Registered-img.png";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

let response = "";

const exceptThisSymbols = ["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"];

function JobSeekerRegForm() {
  const ref = React.createRef(null);
  const navigate = useNavigate();
  // const theme = useTheme();
  //  translation
  const { t, i18n, ready } = useTranslation();
  const { locationData, locatioError } = useLocationFind();
  const axiosData = useAxios();
  const [WorkType, SetWorktype] = useState("Fresher");
  const [active, setActive] = useState(null);
  const [graduationType, SetgraduationType] = useState("Student");
  const [data, setData] = useState(false);
  const [file, setFile] = useState("");
  const [resume, setResume] = useState("");
  const [open, setOpen] = useState(false);
  let [mobileError, setmobileError] = useState("");
  let [emailError, setEmailError] = useState(true);
  const [valid, setvalid] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [focusout, setfocus] = useState();
  const [formEmail, setFormEmail] = useState("");
  const [formEmailError, setFormEmailError] = useState("");
  const [focusb, setfocusb] = useState();
  const [focusPin, setFocusPin] = useState(false);
  const [emailPopUp, setEmailPopUp] = useState(false);
  const [mobilePopUp, setMobilePopUp] = useState(false);
  const [industryArray, setIndustryArray] = useState();

  const storedArea = localStorage.getItem("currentLocationArea");
  const storedPincode = localStorage.getItem("currentLocationPincode");
  const storedState = localStorage.getItem("currentLocationState");
  const storedCountry = localStorage.getItem("currentLocationCountry");

  const handleClick1 = () => {
    setOpen(true);
  };
  const handleClose1 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const [experience, setExperience] = useState([]);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const filterOptions = (options, { inputValue }) => {
    const inputValueLower = inputValue.toLowerCase();
    const startsWithInput = [];
    const containsInput = [];

    options.forEach((option) => {
      const optionLower = option.toLowerCase();
      if (optionLower.startsWith(inputValueLower)) {
        startsWithInput.push(option);
      } else if (optionLower.includes(inputValueLower)) {
        containsInput.push(option);
      }
    });

    return [...startsWithInput, ...containsInput];
  };

  const MAX_FILE_SIZE = 1048576 * 10;
  const errors = {};
  const error = () => {
    errors.email_id = `email is exist `;
  };
  const [alertm, setalert] = useState(false);
  const [alerte, setalerte] = useState(false);
  useEffect(() => {
    if (alertm !== false) {
      setMobilePopUp(true);
      formik.setFieldValue("mobile_number", "");
    }
    setalert(false);
  }, [alertm]);
  useEffect(() => {
    if (alerte !== false) {
      setEmailPopUp(true);
      setFormEmail("");
      formik.setFieldValue("email_id", "");
    }
    setalerte(false);
  }, [alerte]);
  const validate = async (values) => {
    const errors = {};

    if (!values.mobile_number) {
      errors.mobile_number = t("Mobile_Number_must_be_Required");
      setfocusb(true);
      setvalid(true);
    } else if (/^\d{9}$/.test(values.mobile_number)) {
      setvalid(true);
    } else if (/^\d{10}$/.test(values.mobile_number)) {
      if (valid) {
        const controller = new AbortController();
        try {
          const response = await axiosData.get(
            `users/Mobile/${values.mobile_number}`
          );

          if (response.status === 200) {
            setalert(true);
          } else if (response.status === 204) {
            setalert(false);
          }

          setvalid(false);

          return () => controller.abort();
        } catch (error) {}
      }
    }

    return errors;
  };
  const fileInputField = useRef(null);
  const reader = new FileReader();
  const [selectedIndustry, setSelectedIndustry] = useState();
  const handleFileChange = (e) => {
    if (e.target.files[0].size > MAX_FILE_SIZE) {
      setFile("File is too large");
      setResume(false);
    } else {
      setResume(e.target.files[0]);
      setFile(e.target.files[0].name);
    }
    setData(e.target.files[0].size);
  };
  const deleteFile = () => {
    fileInputField.current.value = "";
    setFile(null);
    setData(null);
    setResume(null);
    formik.setFieldValue("fileUpload", null);
  };
  const formik = useFormik({
    initialValues: {
      full_name: "",
      gender: "Male",
      email_id: "",
      mobile_number: "",
      industry: "",
      Experience: "",
      work_status: "Fresher",
      currentLocation: "",
      votingDistrict: "",
      mpConstituency: "",
      mlaConstituency: "",
      pincode: "",
      fileUpload: null,
      graduation: "Student",
      area_name: "",
      pincode_num: "",
      state: "Tamil Nadu",
      country: "",
    },
    validate,
    validationSchema: Yup.object({
      full_name: Yup.string()
        .min(3, t("Must_be_3"))
        .max(50, t("Must_be_50_characters_or_less"))
        .required(t("FullName_must_be_Required"))
        .matches(/^[^'].*[^']$/, t("Invalid_format"))
        .test(
          t("no_repeated_single_quotes"),
          t("String_cannot"),
          (value) => {
            return !/^'{2,}(?:\s*'{1,}[^']*')*'$/.test(value);
          }
        )
        .test(
          t("no_repeated_single_quotes"),
          t("String_must_contain"),
          (value) => {
            return value !== "' '";
          }
        )
        .test(
          t("no_repeated_single_quotes"),
          t("String_must_contain"),
          (value) => {
            return value !== "' ' ' '";
          }
        )
        .test(
          t("no_repeated_single_quotes"),
          t("String_must_contain"),
          (value) => {
            return value !== "''";
          }
        ),
      gender: Yup.string().required("gender must be Required"),
      mobile_number: Yup.number()
        .min(6000000000, t("Not_Valid_Mobile_Number!"))
        .max(9999999999, t("Not_Valid_Mobile_Number!"))
        .required(t("Mobile_Number_must_be_Required")),
      industry: Yup.string().required(t("Select_Industry")),
      currentLocation: Yup.string()
        .max(50, t("Must_be_50_characters_or_less"))
        .required(t("Current_Location_must_be_Required")),
      // votingDistrict: Yup.string().required(t("Select_District")),
      // mpConstituency: Yup.string().required(t("Select_MP_Constituency")),
      // mlaConstituency: Yup.string().required(t("Select_MLA_Constituency")),
      // pincode: Yup.string().required(t("pincode_is_Required")),
      Experience:
        WorkType === "Experienced"
          ? Yup.string().required(t("Experience_is_required"))
          : Yup.string(),
      graduation: Yup.string().required("graduation must be Required"),
      state: Yup.string().required("state must be Required"),
    }),
    onSubmit: (values) => {},
  });
  const submitForm = (values) => {
    let mla = values.mlaConstituency;
    let mla2 = mla.replace(/[-\s.,]+/g, "");
    values.mlaConstituency = mla2;

    if (resume) {
      values.fileUpload = resume;
      values.email_id = formEmail;
    }
    if (graduationType) {
      values.work_status = WorkType;
    }
    if (pincodeNumData) {
      values.pincode_num = pincodeNumData[0];
      values.area_name = pincodeNumData[1];
    }
    if (storedCountry) {
      values.country = storedCountry;
    }
    setIsSubmitting(true);
    axiosData
      .post("seekers", values, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        axiosData.post(
          "users",
          {
            usertype: "seeker",
            status: "InActive",
            uniqueId: values.mobile_number,
            password: values.mobile_number,
            email_id: values.email_id,
            user_id: res.data.user_id,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setIsSubmitting(false);
        formik.handleReset("");
        deleteFile();
        // navigate(
        //   `${ROUTINGDATA.LAND}${ROUTINGDATA.MAIN}${ROUTINGDATA.ThankYou}`
        // );
        handleClickOpened();
        setFile(false);
        handleClick1();
      })
      .catch((err) => console.log(err));
  };
  const handleEmailBlur = () => {
    if (!formEmail) {
      setFormEmailError(t("EmailId_must_be_Required"));
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formEmail)) {
      setFormEmailError(t("Invalid_email_format"));
    } else {
      setFormEmailError("");
    }
  };
  const handleChange = (e) => {
    setfocusb(false);
    const { value } = e.target;
    if (value.length <= 10) {
      formik.handleChange(e);
    }
  };

  const handleChange1 = (e) => {
    setFocusPin(false);
    const { value } = e.target;
    if (value.length <= 6) {
      formik.handleChange(e);
    }
  };

  const handleEmailChange = async (event) => {
    const email_id = event.target.value
      .replace(/[^a-z0-9@.]/gi, "")
      .toLowerCase();
    setFormEmail(email_id);
    if (!email_id) {
      setfocus(true);
      setFormEmailError(t("EmailId_must_be_Required"));
      errors.email_id = t("EmailId_must_be_Required");
      setEmailError(true);
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email_id)) {
      setfocus(false);
      setFormEmailError(t("Invalid_email_format"));
      errors.email_id = t("Invalid_email_format");
    } else if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email_id)) {
      setEmailError(true);
      if (emailError) {
        try {
          const response = await axiosData.post(`users/email`, {
            email_id: email_id,
          });

          if (response.status === 200) {
            setalerte(true);
          } else if (response.status === 204) {
            formik.setFieldValue("email_id", event.target.value);

            setFormEmailError("");
          }
        } catch (error) {
          formik.setFieldValue("email_id", event.target.value);

          setFormEmailError("");
        }
      }
    }
  };
  const [mpConstituency, setMP] = useState({
    code: 4,
    District: "",
    ParlimentConstituency: [],
  });
  var [mlaConstituency, setMLA] = useState([]);

  const [districtData, setDistrictData] = useState([]);
  const [district, setDistrict] = useState([]);
  const vodingDistrict = async () => {
    try {
      const getOneAxios = await axiosData.get(`/district`);
      const data = getOneAxios.data;
      if (data) {
        const getDistrict = data.map((i) => {
          return i.District;
        });
        getDistrict.sort();
        setDistrictData(getDistrict);
        setDistrict(data);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  const PuducherryState = async () => {
    try {
      const getOneAxios = await axiosData.get(`/General/Puducherry`);
      const data = getOneAxios?.data?.collections?.data;
      if (data) {
        const getDistrict = data.map((i) => {
          return i.District;
        });

        getDistrict.sort();
        setDistrictData(getDistrict);
        setDistrict(data);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  useEffect(() => {
    if (formik.values.state === "Tamil Nadu") {
      vodingDistrict();
    }
    if (formik.values.state === "Puducherry") {
      PuducherryState();
    }
  }, [formik.values.state]);

  const mlaSelection = (value) => {
    formik.setFieldValue("mpConstituency", "");
    formik.setFieldValue("mlaConstituency", "");
    if (district.length > 0) {
      district.map((element) => {
        if (element.District === value) {
          setMLA([]);
          setMP({ ...element });
        }
      });
    } else {
    }
  };
  const lang = sessionStorage.getItem("lang");

  const IndustryData = async () => {
    try {
      const getOneAxios = await axiosData.get(`/General/seekerSettings`);
      const data = getOneAxios?.data?.industryData;
      if (data) {
        setIndustryArray(data);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  const experienceData = async () => {
    try {
      const getOneAxios = await axiosData.get(`/General/yearOfExperience`);
      const data = getOneAxios?.data?.experience;
      if (data) {
        const datasexp = data.filter((values) => values != "0");
        setExperience(datasexp);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  const [adDistrict, setAdDistrict] = useState([]);
  const [PincodeData, setPincodeData] = useState([]);
  const [PostOfficeData, setPostOfficeData] = useState([]);
  const [newPincode, setPincode] = useState([]);
  const [comdata, setComdata] = useState([]);
  const [pinLoad, setpinLoad] = useState(false);

  const areaPincode = async (values) => {
    setAdDistrict(values);

    try {
      setpinLoad(true);
      let getOneAxiospin = [];

      if (formik.values.state === "Tamil Nadu") {
        let getOneAxiospin1 = await axiosData.get(
          `/distritarea/getArea/${values}`
        );
        getOneAxiospin = getOneAxiospin1.data;
      } else {
        const getOnepinAxios = await axiosData.get(
          `/General/PuducherryPostoffice`
        );
        const data = getOnepinAxios?.data?.collections?.data;

        if (data) {
          const getDistrictPin = data.filter((i) => {
            return i.District === values;
          });
          getOneAxiospin = [...getDistrictPin];
        }
      }
      setpinLoad(false);
      const datapin = getOneAxiospin;
      if (datapin) {
        const getpin = datapin.map((i) => {
          return i.Pincode;
        });
        const getpost = datapin.map((i) => {
          return i.Post_Office;
        });
        const getpost1 = getpost[0];
        const result = getpin[0].reduce(
          (accumulator, currentPincode, index) => {
            return accumulator.concat(`${currentPincode}/${getpost1[index]}`);
          },
          []
        );
        const getPostFinal = result.map((i) => {
          return i;
        });
        setPincodeData(getpin[0]);
        setPostOfficeData(getpost[0]);
        setPincode(datapin);
        setComdata([...getPostFinal]);
      }

      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  useEffect(() => {
    if (
      (storedArea === "" || storedArea === null || storedArea === undefined) &&
      (storedPincode === "" ||
        storedPincode === null ||
        storedPincode === undefined) &&
      (storedCountry === "" ||
        storedCountry === null ||
        storedCountry === undefined) &&
      (storedState === "" ||
        storedPincode === null ||
        storedPincode === undefined)
    ) {
      formik.setFieldValue("currentLocation", "");
    } else {
      //formik.setFieldValue("currentLocation", `${storedArea},${storedPincode}`);
    }
  }, [locationData]);

  useEffect(() => {
    vodingDistrict();
    IndustryData();
    experienceData();
  }, []);

  const handleClickWorkType = (e, id) => {
    e.preventDefault();
    setActive(id);
    if (id === "6") {
      SetWorktype("Fresher");
      formik.setFieldValue("Experience", "");
    } else if (id === "1") {
      SetWorktype("Experienced");
    }
  };

  useEffect(() => {
    if (formik.values.graduation === "Student") {
      SetWorktype("Fresher");
      formik.setFieldValue("Experience", "");
      setActive("6");
    }
    SetgraduationType(formik.values.graduation);
  }, [formik.values.graduation]);

  const handleStudentClick = () => {
    SetWorktype("Fresher");
    formik.setFieldValue("Experience", "");
    setActive("6");
  };

  const [pincodeNumData, setPincodeNumData] = useState([]);
  const [pincodeValue, setPincodeValue] = useState("");

  useEffect(() => {
    if (pincodeValue) {
      const parts = pincodeValue.split("/");
      if (parts.length === 2) {
        setPincodeNumData(parts);
      }
    }
  }, [formik.values.pincode]);

  const themeds = useTheme();
  const [openok, setOpenok] = React.useState(false);
  const fullScreen = useMediaQuery(themeds.breakpoints.down("md"));

  const handleClickOpened = () => {
    setOpenok(true);
  };

  const handleCloseed = () => {
    setOpenok(false);
    navigate(ROUTINGDATA.LAND);
  };

  if (ready) {
    return (
      <>
        <Dialog TransitionComponent={Transition} open={emailPopUp}>
          <DialogTitle
            bgcolor="rgb(16 143 178)"
            sx={{ color: "white", fontWeight: 600 }}
          >
            {t("Email_Exits")}
          </DialogTitle>
          <DialogContent sx={{ mt: 3 }}>
            <DialogContentText sx={{ fontWeight: 600 }}>
              {t("This_Email_Id_already_exist")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setEmailPopUp(false)}
            >
              {t("Ok")}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog TransitionComponent={Transition} open={mobilePopUp}>
          <DialogTitle
            bgcolor="rgb(16 143 178)"
            sx={{ color: "white", fontWeight: 600 }}
          >
            {t("Mobile_Number_Exits")}
          </DialogTitle>
          <DialogContent sx={{ mt: 3 }}>
            <DialogContentText sx={{ fontWeight: 600 }}>
              {t("This_Mobile_number_already_exist")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setMobilePopUp(false)}
            >
              {t("Ok")}
            </Button>
          </DialogActions>
        </Dialog>
        <div className="overall-jobseeker-form">
          <div className="left-jobseekers-img">
            <div style={{ visibility: "hidden" }}>fsdfsd</div>
            <div className="leftimg-box">
              <img src={lang === "tamil" ? leftTamil : leftimg} alt="img" />
            </div>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="jobseeker-form-box">
              <div className="jobseeker-form-header">
                <h2>
                  <span>{t("JobSeeker")}</span> {t("Registration")}
                </h2>
              </div>
              <div className="jobseeker-box-reg-form">
                <div className="jobseeker-box-inputs">
                  <div className="jobseeker-textfield">
                    <label>{t("Full_Name")}<text>*</text></label>
                    <TextField
                      sx={{ marginTop: "8px", backgroundColor: "white" }}
                      id="full_name"
                      required
                      variant="outlined"
                      size="small"
                      name="full_name"
                      placeholder={t("Enter_Your_Full_Name")}
                      onBlur={formik.handleBlur}
                      fullWidth
                      onChange={(e) => {
                        if (e) {
                          const name = e.target.value.replace(
                            /[^a-z'. ]/gi,
                            ""
                          );
                          formik.setFieldValue("full_name", name);
                        }
                      }}
                      value={formik.values.full_name}
                      InputLabelProps={{
                        style: { color: "black" },
                      }}
                      InputProps={{
                        // ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <PersonIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <FormHelperText>
                      {formik.touched.full_name && formik.errors.full_name ? (
                        <Typography sx={{ color: "red", fontSize: "13px" }}>
                          {formik.errors.full_name}
                        </Typography>
                      ) : (
                        <Typography sx={{ visibility: "hidden",fontSize: "13px"  }}>
                          none
                        </Typography>
                      )}
                    </FormHelperText>
                  </div>
                  <div className="jobseeker-textfield">
                    <label>{t("Email_Id")}<text>*</text></label>
                    {/* <Tooltip title="Enter your Email" arrow> */}
                    <TextField
                      sx={{ marginTop: "8px", backgroundColor: "white" }}
                      id="email_id"
                      variant="outlined"
                      size="small"
                      required
                      ref={ref}
                      onBlurCapture={() => {
                        setfocus(true);
                      }}
                      name="formEmail"
                      placeholder={t("Enter_Your_Email_ID")}
                      onBlur={handleEmailBlur}
                      onChange={handleEmailChange}
                      value={formEmail}
                      fullWidth
                      InputLabelProps={{
                        style: { color: "black" },
                      }}
                      InputProps={{
                        // ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <EmailIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                    {/* </Tooltip> */}
                    <FormHelperText>
                      {formEmailError && focusout ? (
                        <Typography sx={{ color: "red", fontSize: "13px" }}>
                          {formEmailError}
                        </Typography>
                      ) : (
                        <Typography
                          sx={{ fontSize: "13px", visibility: "hidden" }}
                        >
                          none
                        </Typography>
                      )}
                    </FormHelperText>
                  </div>
                  <div className="jobseeker-textfield">
                    <label>{t("Mobile_Number")}<text>*</text></label>
                    {/* <Tooltip title="Enter Your Mobile Number" arrow> */}
                    <TextField
                      sx={{ marginTop: "8px", backgroundColor: "white" }}
                      required
                      id="mobile_number"
                      variant="outlined"
                      size="small"
                      type="number"
                      name="mobile_number"
                      placeholder={t("Enter_Your_Mobile_Number")}
                      onWheel={(e) => {
                        e.preventDefault();
                        e.target.blur();
                      }}
                      onKeyDown={(e) =>
                        exceptThisSymbols.includes(e.key) && e.preventDefault()
                      }
                      onBlurCapture={() => {
                        setfocusb(true);
                      }}
                      onBlur={formik.handleBlur}
                      onChange={handleChange}
                      value={formik.values.mobile_number}
                      fullWidth
                      InputLabelProps={{
                        style: { color: "black" },
                      }}
                      InputProps={{
                        // ...params.InputProps,
                        startAdornment: (
                          <InputAdornment position="start">
                            <span
                              style={{
                                fontSize: "medium",
                                fontFamily: "Poppins-SemiBold",
                              }}
                            >
                              +91
                            </span>
                          </InputAdornment>
                        ),
                      }}
                    />
                    {/* </Tooltip> */}
                    <FormHelperText>
                      {mobileError && focusb ? (
                        <Typography sx={{ color: "red", fontSize: "13px" }}>
                          {mobileError}
                        </Typography>
                      ) : formik.touched.mobile_number &&
                        formik.errors.mobile_number &&
                        focusb ? (
                        <Typography sx={{ color: "red", fontSize: "13px" }}>
                          {formik.errors.mobile_number}
                        </Typography>
                      ) : (
                        <Typography
                          sx={{ fontSize: "13px", visibility: "hidden" }}
                        >
                          none
                        </Typography>
                      )}
                    </FormHelperText>
                  </div>
                  <div className="jobseeker-textfield">
                    <label>{t("Gender")}<text>*</text></label>
                    <div className="jobseeker-btn-img">
                      <Stack direction="row" className="mobile-for-gender">
                        <Button
                          className={
                            formik.values.gender === "Male"
                              ? "jobseeker-btn-gender-active"
                              : "jobseeker-btn-gender"
                          }
                          variant="outlined"
                          onClick={(e) => {
                            formik.setFieldValue("gender", "Male");
                          }}
                        >
                          {formik.values.gender === "Male" ? (
                            <img src={svgmaleActive} />
                          ) : (
                            <img src={svgmale} />
                          )}
                          <span
                            className={
                              formik.values.gender === "Male"
                                ? "btn-space-name-active"
                                : "btn-space-name"
                            }
                          >
                            {t("Male")}
                          </span>
                        </Button>
                        <Button
                          className={
                            formik.values.gender === "Female"
                              ? "jobseeker-btn-gender-active"
                              : "jobseeker-btn-gender"
                          }
                          variant="outlined"
                          onClick={(e) => {
                            formik.setFieldValue("gender", "Female");
                          }}
                        >
                          {formik.values.gender === "Female" ? (
                            <img className="girlimg" src={svggirlActive} />
                          ) : (
                            <img className="girlimg" src={svggirl} />
                          )}
                          <span
                            className={
                              formik.values.gender === "Female"
                                ? "btn-space-name-active"
                                : "btn-space-name"
                            }
                          >
                            {t("Female")}
                          </span>
                        </Button>
                        <Button
                          className={
                            formik.values.gender === "Other"
                              ? "jobseeker-btn-gender-active"
                              : "jobseeker-btn-gender"
                          }
                          startIcon={
                            formik.values.gender === "Other" ? (
                              <DoNotDisturbIcon className="gendericon-Active" />
                            ) : (
                              <DoNotDisturbIcon className="gendericon" />
                            )
                          }
                          onClick={(e) => {
                            formik.setFieldValue("gender", "Other");
                          }}
                        >
                          <span
                            className={
                              formik.values.gender === "Other"
                                ? "btn-space-name-1-active"
                                : "btn-space-name-1"
                            }
                          >
                            {t("Other")}
                          </span>
                        </Button>
                      </Stack>
                    </div>
                    <FormHelperText>
                      <div style={{ visibility: "hidden" }}>wsdwdqw</div>
                    </FormHelperText>
                  </div>
                  <div
                    className="jobseeker-textfield"
                    style={{ marginBottom: "10px" }}
                  >
                    <label>{t("Graduation")}<text>*</text></label>
                    <div className="jobseeker-btn-img">
                      <Stack direction="row" spacing={2}>
                        <Button
                          className={
                            formik.values.graduation === "Student"
                              ? "jobseeker-btn-gender-active"
                              : "jobseeker-btn-gender"
                          }
                          variant="outlined"
                          onClick={(e) => {
                            formik.setFieldValue("graduation", "Student");
                            formik.setFieldValue("work_status", "Fresher");
                          }}
                        >
                          {formik.values.graduation === "Student" ? (
                            <img src={StudentActive} />
                          ) : (
                            <img src={Student} />
                          )}
                          <span
                            className={
                              formik.values.graduation === "Student"
                                ? "btn-space-name-active"
                                : "btn-space-name"
                            }
                          >
                            {t("Student")}
                          </span>
                        </Button>
                        <Button
                          className={
                            formik.values.graduation === "Graduate"
                              ? "jobseeker-btn-gender-active"
                              : "jobseeker-btn-gender"
                          }
                          variant="outlined"
                          onClick={(e) => {
                            formik.setFieldValue("graduation", "Graduate");
                            formik.setFieldValue("work_status", "Fresher");
                          }}
                        >
                          {formik.values.graduation === "Graduate" ? (
                            <img src={GraduateActive} />
                          ) : (
                            <img src={Graduate} />
                          )}
                          <span
                            className={
                              formik.values.graduation === "Graduate"
                                ? "btn-space-name-active"
                                : "btn-space-name"
                            }
                          >
                            {t("Graduate")}
                          </span>
                        </Button>
                      </Stack>
                    </div>
                    {/* <FormHelperText>
                      {mobileError && focusb ? (
                        <Typography
                          sx={{
                            color: "red",
                            fontSize: "13px",
                            visibility: "hidden",
                          }}
                        >
                          {mobileError}
                        </Typography>
                      ) : (
                        <Typography
                          sx={{
                            color: "red",
                            fontSize: "13px",
                            visibility: "hidden",
                          }}
                        >
                          {formik.errors.mobile_number}
                        </Typography>
                      )}
                    </FormHelperText> */}
                    <FormHelperText>
                      <div style={{ visibility: "hidden" }}>wsdwdqw</div>
                    </FormHelperText>
                  </div>{" "}
                  {formik.values.graduation === "Graduate" ? (
                    <div
                      className="jobseeker-btn-img"
                      style={{ marginBottom: "20px", marginTop: "-13px" }}
                    >
                      <label className="Work_Status">{t("Work_Status")}<text>*</text></label>
                      <Stack
                        direction="row"
                        sx={{ marginTop: "5px" }}
                        spacing={2}
                        className="mobile-for-gender"
                      >
                        <Button
                          size="small"
                          className={
                            formik.values.work_status === "Fresher"
                              ? "jobseeker-btn-gender-active"
                              : "jobseeker-btn-gender"
                          }
                          variant="outlined"
                          onClick={(e) => {
                            handleClickWorkType(e, "6");
                            formik.setFieldValue("work_status", "Fresher");
                          }}
                        >
                          {formik.values.work_status === "Fresher" ? (
                            <img src={fresher} />
                          ) : (
                            <img src={Graduateworksatus} />
                          )}

                          <span
                            className={
                              formik.values.work_status === "Fresher"
                                ? "btn-space-name-active"
                                : "btn-space-name"
                            }
                          >
                            {t("I'm_a_Fresher")}
                          </span>
                        </Button>

                        <Button
                          size="small"
                          className={
                            formik.values.work_status === "Experienced"
                              ? "jobseeker-btn-gender-active"
                              : "jobseeker-btn-gender"
                          }
                          variant="outlined"
                          onClick={(e) => {
                            handleClickWorkType(e, "1");
                            formik.setFieldValue("work_status", "Experienced");
                          }}
                        >
                          {formik.values.work_status === "Experienced" ? (
                            <img src={workactive} />
                          ) : (
                            <img src={workexstatus} />
                          )}

                          <span
                            className={
                              formik.values.work_status === "Experienced"
                                ? "btn-space-name-active"
                                : "btn-space-name"
                            }
                          >
                            {" "}
                            {t("I'm_Experienced")}
                          </span>
                        </Button>
                      </Stack>
                    </div>
                  ) : null}
                  {formik.values.graduation === "Graduate" &&
                  WorkType === "Experienced" ? (
                    <div className="jobseeker-textfield">
                      <Autocomplete
                        disableClearable={
                          formik.values.Experience ? false : true
                        }
                        size="small"
                        name="Experience"
                        id="Experience"
                        sx={{ backgroundColor: "#ffff" }}
                        options={experience}
                        value={formik.values.Experience}
                        onChange={(event, newValue) => {
                          formik.setFieldValue("Experience", newValue);
                        }}
                        onBlur={formik.handleBlur}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={t("Work_Experience")}
                          />
                        )}
                      />
                      <FormHelperText>
                        {formik.touched.Experience &&
                        formik.errors.Experience ? (
                          <Typography sx={{ color: "red", fontSize: "13px" }}>
                            {formik.errors.Experience}
                          </Typography>
                        ) : (
                          <Typography
                            sx={{
                              color: "red",
                              fontSize: "13px",
                              visibility: "hidden",
                            }}
                          >
                            none
                          </Typography>
                        )}
                      </FormHelperText>
                    </div>
                  ) : null}
                  {industryArray && (
                    <div className="jobseeker-textfield">
                      <label>{t("Select_Industry")}<text>*</text></label>
                      {industryArray && (
                        <>
                          <Autocomplete
                            sx={{ marginTop: "8px", backgroundColor: "white" }}
                            disableClearable={
                              formik.values.industry ? false : true
                            }
                            filterOptions={filterOptions}
                            size="small"
                            id="industry"
                            name="industry"
                            options={industryArray}
                            onBlur={formik.handleBlur}
                            onChange={(event, value) => {
                              setSelectedIndustry(value);
                              formik.setFieldValue("industry", value);
                            }}
                            value={formik.values.industry}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                placeholder={t("Preffered_Industry")}
                                id="industry"
                                name="industry"
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <img
                                        className="Industryimg"
                                        src={Industry}
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                                // onClick={() => params.inputProps.onInputClick()}
                              />
                            )}
                            onOpen={(event) => event.preventDefault()}
                            PopperComponent={({ children, ...popperProps }) => (
                              <Popper
                                {...popperProps}
                                placement="bottom-start"
                                modifiers={{
                                  flip: {
                                    enabled: false,
                                  },
                                  preventOverflow: {
                                    enabled: true,
                                    boundariesElement: "scrollParent",
                                  },
                                }}
                                PopperProps={{
                                  placement: "bottom-start", // Placement set to "bottom-start"
                                }}
                              >
                                <Paper>{children}</Paper>
                              </Popper>
                            )}
                            ListboxProps={{
                              style: { maxHeight: "180px", overflowY: "auto" },
                            }}
                          />
                          <FormHelperText>
                            {formik.touched.industry &&
                            formik.errors.industry ? (
                              <Typography
                                sx={{ color: "red", fontSize: "13px" }}
                              >
                                {formik.errors.industry}
                              </Typography>
                            ) : (
                              <Typography
                                sx={{
                                  color: "red",
                                  fontSize: "13px",
                                  visibility: "hidden",
                                }}
                              >
                                none
                              </Typography>
                            )}
                          </FormHelperText>
                        </>
                      )}
                    </div>
                  )}

                  <TextField
                    margin="normal"
                    fullWidth
                    required
                    multiline
                    placeholder={t("Mention_the_city_you_live_in")}
                    id="Current Location"
                    label={t("Current_Location")}
                    name="currentLocation"
                    onBlur={formik.handleBlur}
                    onChange={(e) => {
                      if (e) {
                        const value = e.target.value.replace(
                          /[^a-z.,' ]/gi,
                          ""
                        );
                        formik.setFieldValue("currentLocation", value);
                      }
                    }}
                    value={formik.values.currentLocation}
                    InputLabelProps={{
                      style: { color: "black" },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LocationOnIcon />{" "}
                        </InputAdornment>
                      ),
                    }}
                  />
                  {formik.touched.currentLocation &&
                  formik.errors.currentLocation ? (
                    <div style={{ color: "red" }}>
                      {formik.errors.currentLocation}
                    </div>
                  ) : null}

                  {/* <fieldset className="importantBox">
                    <legend>{t("Voting_Details")} </legend>

                    <Container fixed>
                      <Autocomplete
                        size="small"
                        required
                        sx={{ marginTop: "8px", backgroundColor: "white" }}
                        disableClearable={!formik.values.votingDistrict}
                        filterOptions={filterOptions}
                        name="votingDistrict"
                        id="votingDistrict"
                        value={formik.values.votingDistrict}
                        onChange={(e, newValue, reason) => {
                          if (reason === "clear" || newValue === "") {
                            formik.setFieldValue("votingDistrict", "");
                            formik.setFieldValue("mpConstituency", "");
                            formik.setFieldValue("mlaConstituency", "");
                            formik.setFieldValue("pincode", "");
                          } else {
                            formik.setFieldValue("votingDistrict", newValue);
                            formik.setFieldValue("mpConstituency", "");
                            formik.setFieldValue("mlaConstituency", "");
                            mlaSelection(newValue);
                            areaPincode(newValue);
                            formik.setFieldValue("pincode", "");
                            formik.setFieldError("votingDistrict", " ");
                          }
                        }}
                        onBlur={formik.handleBlur}
                        options={districtData}
                        //getOptionLabel={(option) => option.title}
                        // defaultValue={top100Films[13]}
                        getOptionLabel={(option) => option}
                        renderInput={(params) => (
                          <TextField
                            required
                            {...params}
                            placeholder={t("Select_District")}
                            name="votingDistrict"
                          />
                        )}
                        onOpen={(event) => event.preventDefault()}
                        PopperComponent={({ children, ...popperProps }) => (
                          <Popper
                            {...popperProps}
                            placement="bottom-start"
                            modifiers={{
                              flip: {
                                enabled: false,
                              },
                              preventOverflow: {
                                enabled: true,
                                boundariesElement: "scrollParent",
                              },
                            }}
                            PopperProps={{
                              placement: "bottom-start",
                            }}
                          >
                            <Paper>{children}</Paper>
                          </Popper>
                        )}
                        ListboxProps={{
                          style: { maxHeight: "180px", overflowY: "auto" },
                        }}
                      />{" "}
                      {formik.touched.votingDistrict &&
                      formik.errors.votingDistrict &&
                      !formik.values.votingDistrict ? (
                        <div style={{ color: "red" }}>
                          {formik.errors.votingDistrict}
                        </div>
                      ) : null}
                      <Tooltip
                        title={
                          formik.values.votingDistrict
                            ? null
                            : t("Select_District")
                        }
                        arrow
                      >
                        <FormControl
                          disabled={formik.values.votingDistrict ? false : true}
                          sx={{ mt: 2 }}
                          fullWidth
                          required
                        >
                          <InputLabel
                            sx={{ ml: 1 }}
                            id="demo-simple-select-label"
                          >
                            {t("MP_Constituency")}
                          </InputLabel>
                          <Select
                            name="mpConstituency"
                            labelId="demo-simple-select-label"
                            id="mpConstituency"
                            label="MP Constituency"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.mpConstituency}
                          >
                            {mpConstituency.ParlimentConstituency.map(
                              (element, index) => {
                                return (
                                  <MenuItem
                                    key={index}
                                    value={element}
                                    onClick={() => {
                                      mlaConstituency = [];
                                      mpConstituency[element].map((element) => {
                                        mlaConstituency.push(element);
                                        setMLA([...mlaConstituency]);
                                        formik.setFieldValue(
                                          "mlaConstituency",
                                          ""
                                        );
                                      });
                                    }}
                                  >
                                    {element}
                                  </MenuItem>
                                );
                              }
                            )}
                          </Select>
                          {formik.touched.mpConstituency &&
                          formik.errors.mpConstituency ? (
                            <div style={{ color: "red" }}>
                              {formik.errors.mpConstituency}
                            </div>
                          ) : null}
                        </FormControl>
                      </Tooltip>
                      <Tooltip
                        title={
                          formik.values.mpConstituency
                            ? null
                            : t("Select_MP_Constituency")
                        }
                        arrow
                      >
                        <FormControl
                          disabled={formik.values.mpConstituency ? false : true}
                          sx={{ mt: 2 }}
                          fullWidth
                          required
                        >
                          <InputLabel
                            sx={{ ml: 1 }}
                            id="demo-simple-select-label"
                          >
                            {t("MLA_Constituency")}
                          </InputLabel>
                          <Select
                            name="mlaConstituency"
                            labelId="demo-simple-select-label"
                            id="mlaConstituency"
                            label="mlaConstituency"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.mlaConstituency}
                          >
                            {mlaConstituency.map((element, index) => {
                              return (
                                <MenuItem key={index} value={element}>
                                  {element}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          {formik.touched.mlaConstituency &&
                          formik.errors.mlaConstituency ? (
                            <div style={{ color: "red" }}>
                              {formik.errors.mlaConstituency}
                            </div>
                          ) : null}
                        </FormControl>
                      </Tooltip>
                      <Tooltip
                        title={
                          formik.values.votingDistrict
                            ? null
                            : t("Select_District")
                        }
                        arrow
                      >
                        <FormControl sx={{ mt: 3, mb: 1 }} fullWidth required>
                          <Autocomplete
                            disabled={
                              formik.values.votingDistrict && !pinLoad
                                ? false
                                : true
                            }
                            disableClearable={
                              formik.values.pincode ? false : true
                            }
                            filterOptions={filterOptions}
                            id="pincode"
                            name="pincode"
                            options={comdata}
                            onBlur={formik.handleBlur}
                            onChange={(event, value) => {
                              formik.setFieldValue("pincode", value);
                              setPincodeValue(value);
                            }}
                            value={formik.values.pincode}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                id="pincode"
                                label={t("Pincode")}
                                name="pincode"
                                InputLabelProps={{
                                  style: { color: "black", marginLeft: "7px" },
                                }}
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      {pinLoad ? (
                                        <CircularProgress
                                          // size={24}
                                          style={{
                                            width: "1.7rem",
                                            height: "1.7rem",
                                            color:
                                              formik.errors.pincode ===
                                                undefined ||
                                              formik.touched.pincode ===
                                                undefined
                                                ? "#1976d5"
                                                : formik.errors.pincode !==
                                                    undefined &&
                                                  formik.touched.pincode ===
                                                    true
                                                ? "#de6363"
                                                : "#666666",
                                          }}
                                        />
                                      ) : (
                                        <ShareLocationRoundedIcon
                                          sx={{
                                            color:
                                              formik.errors.pincode ===
                                                undefined ||
                                              formik.touched.pincode ===
                                                undefined
                                                ? "#1976d5"
                                                : formik.errors.pincode !==
                                                    undefined &&
                                                  formik.touched.pincode ===
                                                    true
                                                ? "#de6363"
                                                : "#666666",
                                          }}
                                        />
                                      )}{" "}
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                            onOpen={(event) => event.preventDefault()}
                            PopperComponent={({ children, ...popperProps }) => (
                              <Popper
                                {...popperProps}
                                placement="bottom-start"
                                modifiers={{
                                  flip: {
                                    enabled: false,
                                  },
                                  preventOverflow: {
                                    enabled: true,
                                    boundariesElement: "scrollParent",
                                  },
                                }}
                                PopperProps={{
                                  placement: "bottom-start", // Placement set to "bottom-start"
                                }}
                              >
                                <Paper>{children}</Paper>
                              </Popper>
                            )}
                            ListboxProps={{
                              style: { maxHeight: "180px", overflowY: "auto" },
                            }}
                          />
                          {formik.touched.pincode && formik.errors.pincode ? (
                            <div style={{ color: "red" }}>
                              {formik.errors.pincode}
                            </div>
                          ) : null}
                        </FormControl>
                      </Tooltip>
                    </Container>
                  </fieldset> */}

                  <Grid className="container">
                    <Grid item sx={{ mt: 0 }} xs={5} sm={5} md={6} lg={6}>
                      <input
                        className="resumefile"
                        id="file-upload"
                        type="file"
                        accept=".docx,.doc,.pdf,"
                        onChange={handleFileChange}
                        ref={fileInputField}
                        required
                      />
                      <div className="fileuploadcenter">
                        <Button
                          disabled={file ? true : false}
                          htmlFor="file"
                          variant="contained"
                          color="error"
                          sx={{ borderRadius: 10, mr: -2 }}
                          className="fileUpload"
                          name="fileUpload"
                          onClick={() => {
                            fileInputField.current.click();
                          }}
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.fileUpload}
                        >
                          <DriveFolderUploadIcon className="resumeIcon" />
                          {t("Upload_Resume")}
                        </Button>
                      </div>
                    </Grid>
                    <Grid sx={{ mt: 2.5 }} item xs={7} sm={7} md={6} lg={6}>
                      {file ? (
                        <div className="fileName">
                          <Typography
                            variant="div"
                            sizewidth="2px"
                            sx={
                              resume
                                ? { color: "rgb(16 143 178)", ml: -1, mb: -1 }
                                : { color: "red", ml: -1, mb: -1 }
                            }
                            className="fileNameSize"
                          >
                            {`${file}`}
                          </Typography>
                          <Tooltip title="Clear" arrow>
                            <IconButton>
                              <CloseIcon
                                className="iconsize"
                                sx={{ color: "red", mb: -0.5 }}
                                onClick={() => {
                                  deleteFile();
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                  <div className="uploadbox">
                    <p>
                      <span
                        style={
                          resume
                            ? { color: "rgb(16 143 178)" }
                            : { color: "red" }
                        }
                        className="fileSize"
                      >
                        {data
                          ? `${data / 1024}` >= 1024
                            ? `${parseFloat(data / 1024 / 1024).toFixed(3)}Mb`
                            : `${parseFloat(data / 1024).toFixed(3)}Kb`
                          : null}
                      </span>{" "}
                      {t("File_must_be")}
                    </p>
                  </div>

                  <Button
                    type="submit"
                    disabled={
                      !formEmailError &&
                      resume &&
                      formik.isValid &&
                      formik.dirty &&
                      isSubmitting === false
                        ? false
                        : true
                    }
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                  >
                    {t("Submit")}
                    {isSubmitting && (
                      <CircularProgress
                        size={24}
                        style={{
                          color: "#ffffff",

                            marginLeft: 12,
                          }}
                        />
                      )}
                      {/* <VisuallyHiddenInput type="file" /> */}
                    </Button>
                  </div>
                </div>
              </div>
          </form>
        </div>
        <Dialog
          fullScreen={fullScreen}
          open={openok}
          aria-labelledby="responsive-dialog-title"
          maxWidth={600}
          className="dailog"
          PaperProps={{
            style: {
              borderRadius: 15,
            },
          }}
        >
          <DialogTitle
            id="responsive-dialog-title"
            sx={{ textAlign: "center", marginTop: "20px" }}
          >
            <p className="Successfully-text">{t("Thank_you_registration")}</p>
            <text className="Check-text">{t("Check_your_mail")}</text>
          </DialogTitle>
          <DialogContent className="ahjahg">
            <DialogContentText>
              <div className="set-widthfordailogbox">
                <div className="img-complete">
                  <img src={sussesfullimg} />
                </div>
                <div>
                  <p className="apply-your-text">{t("dream_jobs")}</p>
                </div>
                <div style={{ textAlign: "center" }}>
                  <Button className="btn-successfully" onClick={handleCloseed}>
                    {t("Home_Page")}
                  </Button>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </>
    );
  } else {
    return (
      <div
        style={{
          height: "70vh",
          display: "grid",
          placeItems: "center",
        }}
      >
        <div class="dots"></div>
      </div>
    );
  }
}
export default JobSeekerRegForm;
